/**
 * 刷新钱包 / 订阅资产到 AssetStore（非 React 环境可调）
 */

import { TradeApi } from '@/apis';
import { useAssetStore } from '@/store/asset';

/**
 * 拉取最新资产并写入 store。
 * @returns 是否成功写入
 */
export async function refreshWalletAsset(): Promise<boolean> {
    try {
        const { data } = await TradeApi.getAsset();
        if (!data) {
            return false;
        }
        useAssetStore.getState().setAssetInfo(data);
        return true;
    } catch (error) {
        console.error('[refreshWalletAsset] failed', error);
        return false;
    }
}
